module.exports = __webpack_public_path__ + "cba963607c66364869a09e398a34783c.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/wings/middown-15.png
// module id = 3139
// module chunks = 0